<template>
  <div class="data-entry">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedTab: '收货数据',
      menuList: [
        {name: '收货数据', url: '/data-import/data-entry/receiving-data'},
        {name: '单量录入', url: '/data-import/data-entry/single-quantity'},
        {name: '人工成本', url: '/data-import/data-entry/labor-cost'},
        {name: '盘点', url: '/data-import/data-entry/inventory'},
        {name: '过期产品录入', url: '/data-import/data-entry/expired-products'},
        {name: '储位管理', url: '/data-import/data-entry/storage-management'},
        {name: '异常订单', url: '/data-import/data-entry/abnormal-order'},
      ],
    }
  },

  created() {
    this.selectedTab = this.$route.meta.menuName
  },

  methods: {
    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },
  }
};
</script>
<style lang="scss">
.data-entry {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  .switch-menu {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 56px;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    padding: 0px 20px;
    box-sizing: border-box;
    .menu-name {
      height: 56px;
      line-height: 56px;
      margin-right: 32px;
      .el-radio-button__inner {
        font-size: 16px;
        font-weight: bold;
        border: none;
        color: #666666;
        background: transparent;
        padding: 0;
      }
      .is-active {
        border-bottom: 2px solid #2E68EA;
        .el-radio-button__inner {
          color: #2E68EA;
        }
      }
    }
  }
}
</style>
